import t from "../../../../helpers/t";
import {in_array} from "../../../../../utils/Helper";
import {Biscuit} from "../../../../../utils";
import React from "react";

const PriceTypesSelect = (props) => {

    const { onChangePricetype, usedPriceTypes, priceLocal, checkPricetypes} = props;

    let check = checkPricetypes(usedPriceTypes,'PricetypesSelect');

    return (
        <>
            <div className="inb-form-group column medium-4 small-6 lang">
                <label className="inb-form__controlLabel">{t('pricetype')}</label>
                <div className="inb-form__controllClass">
                    <select
                        className="inbooma-select-box__input"
                        name="pricetypes"
                        style={{marginTop:'10px',minHeight:"50px"}}
                        onChange={(e) => onChangePricetype(e)}
                        value={typeof priceLocal.pricetype_id === 'undefined' ? "" : priceLocal.pricetype_id}
                        placeholder={t('select_${a}', {a: t('pricetype')})}>
                        <option value="0"> </option>
                        {check.count > 0 && check.pricetypes.map(pricetype => {
                                    return (
                                        <>
                                            { in_array(pricetype.id, usedPriceTypes) &&
                                                <option key={pricetype.id} disabled={"disabled"}
                                                        value={pricetype.id}>{pricetype.name + ' (' + pricetype.description + ')'}</option>
                                            }
                                            { !in_array(pricetype.id, usedPriceTypes) &&
                                                <option key={pricetype.id}
                                                        value={pricetype.id}>{pricetype.name + ' (' + pricetype.description + ')'}</option>
                                            }
                                        </>
                                    )
                                }
                            )}
                    </select>
                </div>
            </div>
        </>
    )
}
export default PriceTypesSelect;